import { IMenuItem } from "../interface/interface";

export function dateHasAvailableSeatings(menuItemsOnDate: IMenuItem[], seatingAvaiable: Map<string,string>){
    var hasAvaialableSeatingOnDate: boolean = false;
    menuItemsOnDate.forEach(menuItemOnDate => {
        menuItemOnDate.selectableSeatings.forEach(selectableSeating => {
            if(seatingAvaiable instanceof Map){
                var available = seatingAvaiable.get(selectableSeating.seating.content.id)
                if(available === "true"){
                    hasAvaialableSeatingOnDate = true
                }
            }
        })
    })
    return hasAvaialableSeatingOnDate
}